import { Pipe, PipeTransform, Injectable } from '@angular/core';
import dayjs from 'dayjs';
import jalaliday from 'jalaliday';
import utc from 'dayjs/plugin/utc';

dayjs.extend(jalaliday);
dayjs.extend(utc);
dayjs.locale('fa');

// ✅ Tehran is UTC+03:30 (no DST)
const TEHRAN_OFFSET_MINUTES = 3 * 60 + 30;

@Pipe({
  name: 'jalaliDate',
  standalone: true,
})
@Injectable({ providedIn: 'root' })
export class JalaliDatePipe implements PipeTransform {
  transform(
    value: string | number | Date | null | undefined,
    format: string = 'HH:mm YYYY/MM/DD'
  ): string {
    if (value == null || value === '') return '';

    // ✅ NEW: اگر ورودی string بود و timezone نداشت، یعنی احتمالاً "تهران" ذخیره شده
    // در این حالت نباید utc() و +3:30 انجام بدیم
    if (typeof value === 'string') {
      const s = value.trim();

      // timezone دارد؟ مثل Z یا +03:30 یا +00:00
      const hasTimezone = /z$/i.test(s) || /[+-]\d{2}:\d{2}$/.test(s);

      // اگر timezone ندارد => فرض می‌کنیم خودش تهران است (برای منوی سفارش‌ها)
      if (!hasTimezone) {
        const local = dayjs(s);
        if (!local.isValid()) return '';
        return local.calendar('jalali').format(format);
      }
    }

    // ✅ حالت قبلی شما (همه جا مثل قبل می‌مونه)
    const d = dayjs.utc(value);
    if (!d.isValid()) return '';

    const formatted = d.add(TEHRAN_OFFSET_MINUTES, 'minute').calendar('jalali').format(format);
    return this.toPersianDigits(formatted);
  }

  private toPersianDigits(value: string): string {
    const persianDigits = ['۰','۱','۲','۳','۴','۵','۶','۷','۸','۹'];
    return value.replace(/\d/g, (digit) => persianDigits[Number(digit)] ?? digit);
  }
}
